import { DTOFigmaNodeRenderInput } from "./figma-node";
import { DTOFigmaNodeV2 } from "./figma-node-v2";
import { z } from "zod";
//
// Read
//
export const DTOFigmaNodeRenderAsyncActionOutput = z.object({
    type: z.literal("FigmaNodeRenderAsync"),
    figmaNodes: z.array(DTOFigmaNodeV2),
});
//
// Read
//
export const DTOFigmaNodeRenderAsyncActionInput = z.object({
    type: z.literal("FigmaNodeRenderAsync"),
    nodes: DTOFigmaNodeRenderInput.array(),
});
